import { BaseService } from './BaseService';
import {
  IntegrationOperation,
  IntegrationProvider,
  integrationOperationsRepository,
} from '../repositories/IntegrationOperationsRepository';

export class IntegrationOperationsService extends BaseService {
  private repository = integrationOperationsRepository;

  /**
   * Get provider by slug
   */
  async getProviderBySlug(slug: string): Promise<IntegrationProvider | null> {
    return integrationOperationsRepository.getProviderBySlug(slug);
  }

  /**
   * Get all operations for a specific provider
   */
  async getOperationsByProvider(providerId: string): Promise<IntegrationOperation[]> {
    return integrationOperationsRepository.getOperationsByProvider(providerId);
  }

  /**
   * Get all operations for SuccessWare provider
   */
  async getSuccessWareOperations(): Promise<IntegrationOperation[]> {
    return integrationOperationsRepository.getSuccessWareOperations();
  }

  /**
   * Get operation by ID
   */
  async getOperationById(id: string): Promise<IntegrationOperation | null> {
    return integrationOperationsRepository.getOperationById(id);
  }

  /**
   * Search operations by text
   */
  async searchOperations(
    providerId: string,
    searchText: string
  ): Promise<IntegrationOperation[]> {
    if (!searchText.trim()) {
      return this.getOperationsByProvider(providerId);
    }
    return integrationOperationsRepository.searchOperations(providerId, searchText);
  }

  /**
   * Get operations by direction (push/pull)
   */
  async getOperationsByDirection(
    providerId: string,
    direction: string
  ): Promise<IntegrationOperation[]> {
    return integrationOperationsRepository.getOperationsByDirection(providerId, direction);
  }

  /**
   * Get operations by family (core/bookit)
   */
  async getOperationsByFamily(
    providerId: string,
    family: string
  ): Promise<IntegrationOperation[]> {
    return integrationOperationsRepository.getOperationsByFamily(providerId, family);
  }
}

export const integrationOperationsService = new IntegrationOperationsService();
